<template>


         <div class="col-12 px-0 d-lg-none">
        <button v-b-modal.modal-1 class="search_icons_btn" :class="isRTL ? 'ml-3' :'mr-3'">
          <img src="@/assets/img/icons/search.svg"/>
          </button>

    <div  class="search_modal" >
        <b-modal id="modal-1"
          hide-header
          hide-footer
          content-class="search-modal-sub"
          ref="searchModal"
         >
         <div class="jm-search">
              <input
                type="text"
                class="jm-search-ticketak"
                placeholder="Search for Movies"
                v-on:keyup="searchData()"
                v-model="searchValue"
              />
              <div v-if="movieListSearch.length>0" class="search-results">
                <ul class="list-unstyled mb-0">
                  <span class="ml-1 text-grey">{{$t("MOVIES_STATIC")}} </span>
                  <li
                    v-on:click="movieListSearch=[]"
                    v-for="(movie , movieListIndex) in movieListSearch"
                    :key="movieListIndex"
                  >
                    <router-link
                      @click.native="onSearchResultClick"
                      class="text-dark"
                      :to="{ name: 'movie', params: { movieID: movie.Value , cinemaID:'0',props:{selectedFilter, cat_id: movie.CategoryID}}}"
                    >{{movie.Label}}
                    </router-link>
                  </li>
                  <!-- <div class="seprator"></div>
                  <span class="ml-1 text-grey">{{$t("CINEMAS")}}</span>
                  <li
                    v-on:click="cinemaListSearch=[]"
                    v-for="(cinema , cinemaListIndex) in cinemaListSearch"
                    :key="cinemaListIndex"
                  >
                    <router-link
                      class="text-dark"
                      :to="{ name: 'cinemaDetails', params: { cinemaId: cinema.Value }}"
                    >{{cinema.Label}}</router-link>
                  </li> -->
                </ul>
              </div>
            </div>
        </b-modal>
        </div>
      </div>

   
</template>
<script>
import throttle from "lodash.throttle";
import Search from "../search/Search.vue";
import { EventBus } from "@/main";
import { setI18nLanguage } from "@/plugins/i18n";
// import firebase from 'firebase'
import {
  PROJECT,
  METAWEBSITE,
  METAORGANIZATION,
  metaInfo
} from "@/helper/constant.js";
import { makeRequest } from "@/helper/internet.js";
//import VeeValidate from "vee-validate";
import {
  LanguageService,
  CountryService,
  TokenService,
  ReferralService
} from "@/services/storage.service";
import { validationMixin } from "vuelidate";
import { required, minLength, email, password } from "vuelidate/lib/validators";
import VeeValidate from "vee-validate";
import router from "../../router";
import {mapGetters} from 'vuex'
//import Zendesk from "@dansmaculotte/vue-zendesk";

VeeValidate.Validator.extend("verify_password", {
  getMessage: field =>
    `The password must contain at least: one uppercase character, one lowercase character, one number, and one special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});

VeeValidate.Validator.extend("verify_forgot_passwrd", {
  getMessage: field =>
    `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
  validate: value => {
    var strongRegex = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
    );
    return strongRegex.test(value);
  }
});

export default {
  name:"SearchNew",
  components: {},
  computed: {
    ...mapGetters(['isRTL']),
    allLanguageDataMenu(){
      let array= [
                {
                    "name": "HOME",
                    "path": "/"
                },
                {
                    "name": "MOVIES",
                    "path": "/movies"
                },
                {
                    "name": "CINEMAS",
                    "path": "/cinemas"
                },

            ]
         if(this.selectedLang=='en' && false){
           array.push(  {
                    "name": "REFER_SAVE",
                    "path": "/refer"
                })
         }
        return array;

    }
  },
  data() {
    return {
      // Jigar
      // tempToken: null,
      // Jigar
      showBonusPopup: false,
      myUserDetails: {},
      DefaultCountryCode: null,
      project: PROJECT,
      metaWebsite: METAWEBSITE,
      metaOrganization: METAORGANIZATION,
      tempToken: null,
      referralCode: "",
      searchValue: "",
      movieListSearch: [],
      selectedFilter: {},
      languageData: [],
      cinemaListSearch: [],
      fbSignInParams: {
        scope: "email",
        return_scopes: false
      },
      /**
       * The Auth2 parameters, as seen on
       * https://developers.google.com/identity/sign-in/web/reference#gapiauth2initparams.
       * As the very least, a valid client_id must present.
       * @type {Object}
       */
      googleSignInParams: {
        // clientId: 'YOUR_APP_CLIENT_ID.apps.googleusercontent.com'

        //"254680074981-k57uhepk3ve5s85gqepnoiola2baboq6.apps.googleusercontent.com" //mytiketi
        //"193276772057-94fl0er49a467hjm0m1jmpnm7ondunjf.apps.googleusercontent.com" //ticketak

        // client_id: "715055681361-1ku1nj1gptsogqi2ldoelotpltjepvql.apps.googleusercontent.com",
        // clientId: "715055681361-1ku1nj1gptsogqi2ldoelotpltjepvql.apps.googleusercontent.com",

        client_id: "363473089674-i72te70v7gmtftp9e8b1bk2e0d72m9kl.apps.googleusercontent.com",
        clientId: "363473089674-i72te70v7gmtftp9e8b1bk2e0d72m9kl.apps.googleusercontent.com",
      },
      loggedInFlag: false,
      countries: [],
      country: "",
      city: "",
      countrySelected: "",
      citySelected: "",
      onScroll: true,
      forgotPasswordSection: 0,
      page: "",
      cityDropDown: false,
      searchValue: "",
      mobileSearch: false,
      searchQuery: "",
      options: {
        placeholder: "Search for Movies & Cinemas",
        inputClass: "header-input-box form-control",
        inputMainClass: "header-input-box form-control"
      },
      mobileOptions: {
        placeholder: "Search for Movies & Cinemas",
        inputClass: "sb-search-input",
        inputMainClass: ""
      },
      resErrorMessage: {
        signUpError: "",
        signInError: "",
        otpError: "",
        Attempt: false
      },
      loginErrorMessage: "Please Enter Your Credentials",
      registerErrorMessage: "ENTER CONTACT INFORMATION",
      errorMessage: {
        userName: "",
        email: "",
        phoneNumber: "",
        password: "",
        conditions: false
      },
      errorMessageStatus: {
        userName: false,
        email: false,
        phoneNumber: false,
        password: false,
        conditions: false
      },
      status: {
        signUpFlag: true
      },
      inputData: {
        userName: "",
        email: "",
        phoneNumber: "",
        password: "",
        conditions: false,
        code: "",
        ReSetCode: ""
      },
      options: [
        { text: "Male", value: "1" },
        { text: "Female", value: "0" }
      ],
      selected: "1",
      classFlag: {
        onSignUp: "",
        onOTP: "",
        otpComplete: "",
        onSignIn: ""
      },
      // User Details
      userDetails: {
        displayName: "",
        username: "",
        password: "",
        NewPassword: "",
        fullName: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        confirmedPassword: "",
        countryCode: "",
        OTP: "",
        signinmodel: "",
        password: "",
        repassword: "",
        Male: "",
        Female: ""
      },
      modal: {
        signUp: {
          info: true,
          OTP: false
        },
        signIn: {
          info: true,
          OTP: false
        },
        forgotPassword: {
          info: true,
          OTP: false,
          resetPassword: false
        }
      },
      passwordBool: true,
      CountryCodeList: [],
      selectedQuery: "Select Query",
      contactUsDetails: {
        name: "",
        email: "",
        mobile: "",
        message: "",
        errorMessage: "",
        queries: [
          "Ticket pickup and Home delivery",
          "Offers",
          "Confirmation not received",
          "Cancellation/Exchange request",
          "Winpins/Gift Voucher",
          "Unsuccessful transaction",
          "Ticket booking queries",
          "Cinema related feedback",
          "Others"
        ]
      },
      selectedLang: "en",
      isUserLoggedIn: false,
      // OTP
      otpDetails: {
        otpError: {},
        otpInputs: {
          first: "",
          second: "",
          third: "",
          fourth: ""
        },
        status: {
          buttonFlag: true
        }
      },
      verifyMe: false,
      socialLoginError: {
        error: ""
      },
      loginData: {
        loginInput: {
          email: "",
          password: "",
          conditions: false
        },
        errorMessage: {
          email: "",
          password: "",
          conditions: false
        },
        errorMessageStatus: {
          email: false,
          password: false,
          conditions: false
        },
        button: true
      },
      messageCopy: "",
      emailReg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
    };
  },
  mixins: [validationMixin],
  components: {
    Search
  },
  beforeMount() {
    if (this.project == "ticketak") {
      this.googleSignInParams.client_id =
        "193276772057-94fl0er49a467hjm0m1jmpnm7ondunjf.apps.googleusercontent.com";
    } else if (this.project == "wanasatime") {
      this.googleSignInParams.client_id =
        "254680074981-k57uhepk3ve5s85gqepnoiola2baboq6.apps.googleusercontent.com";
    }
    this.page = this.$route.path;
    let country = CountryService.getCountry();
    let countryObj = {};
    // if (country) {
    //   if (window.location.origin == "http://kw.ticketak.com") {
    //     countryObj = {
    //       CountryID: "115",
    //       CountryName: "Kuwait",
    //       Flag:
    //         "https://img.ticketak.com/assets/images/countryflags/5c779755bdc95.png"
    //     };
    //     CountryService.saveCountry(countryObj);
    //   } else if (window.location.origin == "http://uae.ticketak.com") {
    //     countryObj = {
    //       CountryID: "230",
    //       CountryName: "UAE",
    //       Flag:
    //         "https://img.ticketak.com/assets/images/countryflags/5c7796d3b50ad.png"
    //     };
    //   }
    // }
    // else {

    // this.getAllCountry();
    // }
    this.fetchLanguageData();
    this.token = TokenService.getToken();
    if (this.token) {
      this.loggedInFlag = true;
      this.fetchUserDetails();
    }
  },
  created () {
    window.addEventListener("scroll", this.theScroll)
    // firebase.auth().onAuthStateChanged(user => {
    //   console.log({user})
    //   // this.user = user
    // })
  },

  mounted: function() {
    //this.$zendesk.load("0fa8096b-11c0-45f1-9dfe-e82062b79b75");
    this.getAllCountry();
    this.getGeoLocation();
    this.getAllGetCountryList();
    let lang = LanguageService.getLanguage();
    this.selectedLang = (lang && lang["lang"]) || "en";
    this.referralCode = ReferralService.getReferral() || "";
    EventBus.$on("openSignInModal", () => {
      this.$refs.signInModal.show();
    });
    EventBus.$on("fetchuser", () => {
      this.fetchUserDetails();
    });
    EventBus.$on("openSignUpModal", () => {
      this.referralCode = ReferralService.getReferral() || "";
      console.log("Referral Code :", this.referralCode);
      if (!this.loggedInFlag) {
        this.$refs.signUpModal.show();
      }
    });
    EventBus.$on("selectedCountry", countryName => {
      this.countrySelected = countryName;
    });
    let country = CountryService.getCountry();
    if (country) {
      this.countrySelected = country.CountryName;
    }
    // EventBus.$on("getUserDetails", user => {
    //   //   console.log(">>>>>>>><<<<<<<", user);
    // });

    // EventBus.$on("LoginUser", user => {
    //   if (user.status == true) {
    //     this.loggedInFlag = true;
    //   }
    // });
  },
  methods: {
    onSearchResultClick () {
      this.$refs.searchModal && this.$refs.searchModal.hide();
    },
    // fbFirebaseSignIn () {
    //   let provider = new firebase.auth.FacebookAuthProvider()
    //   firebase
    //     .auth()
    //     .signInWithPopup(provider)
    //     .then((result) => {
    //       console.log({result})
    //       let user = result.user
    //       this.showLoading()
    //       let payload_test = {
    //         "TokenFrom": "Google",
    //         "stoken": "eyJhbGciOiJSUzI1NiIsImtpZCI6IjZmOGUxY2IxNTY0MTQ2M2M2ZGYwZjMzMzk0YjAzYzkyZmNjODg5YWMiLCJ0eXAiOiJKV1QifQ.eyJuYW1lIjoiTXVzaGFoZWVlZCBTeWVkIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hLS9BT2gxNEdoTXdDdjk2S2lEN2FJX0FScTJhcTQzNHhVQTN4OGo2U0Z5V0Z2cHZhND1zOTYtYyIsImlzcyI6Imh0dHBzOi8vc2VjdXJldG9rZW4uZ29vZ2xlLmNvbS93YW5hc2F0aW1lLTkxYWM1IiwiYXVkIjoid2FuYXNhdGltZS05MWFjNSIsImF1dGhfdGltZSI6MTY1Mzk3OTQ3MywidXNlcl9pZCI6IjEydnVVN3QwWE1oZTBZMHg0TVR4TFhwM3lsRTMiLCJzdWIiOiIxMnZ1VTd0MFhNaGUwWTB4NE1UeExYcDN5bEUzIiwiaWF0IjoxNjUzOTc5NDczLCJleHAiOjE2NTM5ODMwNzMsImVtYWlsIjoic211c2hhaGVlZEBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJnb29nbGUuY29tIjpbIjExODE4NDIwMDYxNTA5MzQzMzE2MCJdLCJlbWFpbCI6WyJzbXVzaGFoZWVkQGdtYWlsLmNvbSJdfSwic2lnbl9pbl9wcm92aWRlciI6Imdvb2dsZS5jb20ifX0.f5UhlYf8JmgdsIgm-LpP0v2ThtuT_raZ9T1jVArhCMmCSCWjzY0g5XgddWHc-ipcAJk0UB-wA5kNIlWDmqSHkVfF3ee6a-i-IEvr44Bsc5qv5T-PAA8GnkeG7S4Go21jgeqS6Y-x6ZNx2TlCHNZDMdcNmhrabK81lCa1T-RcKTYmA23_QZleY78gVXimJHDMOlHNdNRbkuYPDPrQlVQUGLjLmptaidGoqjjP2IH9iY-O6bm7qZVUDZLMlfCjuNMkt8sxupvykbuvdexDCRiGhDBTjM2_W5mReZkYmma3pwqnDu9KymxOAd-HMrs4cJTTIBWEVrQ0sVKKb9dMq-jrkA",
    //         "Mobile": "0",
    //         "CountryCode": "0",
    //         "is_num": false,
    //         "ReferralCode": "",
    //         "ReferredBy": "",
    //         "Origin": "https://www.mytiketi.com",
    //         "FireBaseID": "e-9enrXyScGtjZgH2NSrH5:APA91bFfFSFGiL9ub7MXJ7c1ARAFkOfTvoNRMbnN6lCDXSL1C9Sv-kGVdrlmTk6rMYCa7lGN9ijoT20E7JNrPDGz8GLsmL8-UXqcbr9kXsXyz5-1XrbN9f9sH54IGlqzQd9civeYbw3i",
    //         "CountryID": 112,
    //         "LanguageID": 1,
    //         "Latitude": 19.1387165,
    //         "Longitude": 72.8312577
    //       }
    //       let payload = {
    //         FireBaseID: '',
    //         TokenFrom: 'Facebook',
    //         stoken: user.toJSON().stsTokenManager.accessToken || result.credential.idToken,
    //         ReferredBy: this.referralCode
    //       }
    //       // const profile = googleUser.getBasicProfile()
    //       return makeRequest(`/SocialLogin`, 'POST', null, payload)
    //         .then(result => {
    //           console.log({result})
    //           this.hideLoading()
    //           TokenService.saveToken(result.res.data.access_token)
    //           this.hideSignIn()
    //           this.hideSignUp()
    //           this.loggedInFlag = true
    //           this.loginUser(result.res.data.access_token)
    //           this.loggedInFlag = true
    //         })
    //         .catch(error => {
    //           console.log('Google Login Error', error)
    //           this.socialLoginError.error = 'Something went wrong!'
    //           setTimeout(() => {
    //             this.socialLoginError.error = ''
    //           }, 5000)
    //         })
    //     })
    //     .catch((err) => {
    //       console.log(err) // This will give you all the information needed to further debug any errors
    //     })
    // },
    // googleFirebaseSignIn () {
    //   let provider = new firebase.auth.GoogleAuthProvider()
    //   firebase
    //     .auth()
    //     .signInWithPopup(provider)
    //     .then((result) => {
    //       console.log({result})
    //       let user = result.user
    //       this.showLoading()
    //       let payload_test = {
    //         "TokenFrom": "Google",
    //         "stoken": "eyJhbGciOiJSUzI1NiIsImtpZCI6IjZmOGUxY2IxNTY0MTQ2M2M2ZGYwZjMzMzk0YjAzYzkyZmNjODg5YWMiLCJ0eXAiOiJKV1QifQ.eyJuYW1lIjoiTXVzaGFoZWVlZCBTeWVkIiwicGljdHVyZSI6Imh0dHBzOi8vbGgzLmdvb2dsZXVzZXJjb250ZW50LmNvbS9hLS9BT2gxNEdoTXdDdjk2S2lEN2FJX0FScTJhcTQzNHhVQTN4OGo2U0Z5V0Z2cHZhND1zOTYtYyIsImlzcyI6Imh0dHBzOi8vc2VjdXJldG9rZW4uZ29vZ2xlLmNvbS93YW5hc2F0aW1lLTkxYWM1IiwiYXVkIjoid2FuYXNhdGltZS05MWFjNSIsImF1dGhfdGltZSI6MTY1Mzk3OTQ3MywidXNlcl9pZCI6IjEydnVVN3QwWE1oZTBZMHg0TVR4TFhwM3lsRTMiLCJzdWIiOiIxMnZ1VTd0MFhNaGUwWTB4NE1UeExYcDN5bEUzIiwiaWF0IjoxNjUzOTc5NDczLCJleHAiOjE2NTM5ODMwNzMsImVtYWlsIjoic211c2hhaGVlZEBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJnb29nbGUuY29tIjpbIjExODE4NDIwMDYxNTA5MzQzMzE2MCJdLCJlbWFpbCI6WyJzbXVzaGFoZWVkQGdtYWlsLmNvbSJdfSwic2lnbl9pbl9wcm92aWRlciI6Imdvb2dsZS5jb20ifX0.f5UhlYf8JmgdsIgm-LpP0v2ThtuT_raZ9T1jVArhCMmCSCWjzY0g5XgddWHc-ipcAJk0UB-wA5kNIlWDmqSHkVfF3ee6a-i-IEvr44Bsc5qv5T-PAA8GnkeG7S4Go21jgeqS6Y-x6ZNx2TlCHNZDMdcNmhrabK81lCa1T-RcKTYmA23_QZleY78gVXimJHDMOlHNdNRbkuYPDPrQlVQUGLjLmptaidGoqjjP2IH9iY-O6bm7qZVUDZLMlfCjuNMkt8sxupvykbuvdexDCRiGhDBTjM2_W5mReZkYmma3pwqnDu9KymxOAd-HMrs4cJTTIBWEVrQ0sVKKb9dMq-jrkA",
    //         "Mobile": "0",
    //         "CountryCode": "0",
    //         "is_num": false,
    //         "ReferralCode": "",
    //         "ReferredBy": "",
    //         "Origin": "https://www.mytiketi.com",
    //         "FireBaseID": "e-9enrXyScGtjZgH2NSrH5:APA91bFfFSFGiL9ub7MXJ7c1ARAFkOfTvoNRMbnN6lCDXSL1C9Sv-kGVdrlmTk6rMYCa7lGN9ijoT20E7JNrPDGz8GLsmL8-UXqcbr9kXsXyz5-1XrbN9f9sH54IGlqzQd9civeYbw3i",
    //         "CountryID": 112,
    //         "LanguageID": 1,
    //         "Latitude": 19.1387165,
    //         "Longitude": 72.8312577
    //       }
    //       let payload = {
    //         FireBaseID: '',
    //         TokenFrom: 'Google',
    //         stoken: user.toJSON().stsTokenManager.accessToken || result.credential.idToken,
    //         ReferredBy: this.referralCode
    //       }
    //       // const profile = googleUser.getBasicProfile()
    //       return makeRequest(`/SocialLogin`, 'POST', null, payload)
    //         .then(result => {
    //           console.log({result})
    //           this.hideLoading()
    //           TokenService.saveToken(result.res.data.access_token)
    //           this.hideSignIn()
    //           this.hideSignUp()
    //           this.loggedInFlag = true
    //           this.loginUser(result.res.data.access_token)
    //           this.loggedInFlag = true
    //         })
    //         .catch(error => {
    //           console.log('Google Login Error', error)
    //           this.socialLoginError.error = 'Something went wrong!'
    //           setTimeout(() => {
    //             this.socialLoginError.error = ''
    //           }, 5000)
    //         })
    //     })
    //     .catch((err) => {
    //       console.log(err) // This will give you all the information needed to further debug any errors
    //     })
    // },
    onShowModal() {
      this.project == "wanasatime"
        ? this.$root.$emit("bv::show::modal", "countryModalRef")
        : undefined;
    },
  navbarMenu($route_path,menu_path){
    // console.log($route_path,menu_path);
    return String($route_path).toLowerCase() == String(menu_path).toLowerCase()
  },
    strongPassword: function() {},
    checkPassword: function(password) {
      let self = this;
      if (
        password != "" &&
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/.test(
          password
        )
      ) {
        self.passwordBool = false;
      } else {
        self.passwordBool = true;
      }
    },
    // getAllCountry: function(country) {
    //   let countryData = CountryService.getCountry();
    //   makeRequest("/GetCountryList", "POST", null, {})
    //     .then(response => {
    //       const { error, res } = response;

    //       if (!error && res.data.Status) {
    //         this.countries = res.data.List;
    //         // if (countryData == null && this.countries.length > 1) {
    //         // console.log('this.countries header :', this.countries);
    //         //   this.$root.$emit("bv::show::modal", "countryModalRef");
    //         // }
    //         // else if (this.countries.length == 1) {
    //         //   this.countries.map(x => {
    //         //     if (x.CountryID == "230" || x.CountryID == "112") {
    //         //       countryData = x;
    //         //       this.countrySelected = x.CountryName;
    //         //       EventBus.$emit("selectedCountry", this.countrySelected);
    //         //       this.getNowShowingData();
    //         //       this.getAllFilters();
    //         //     }
    //         //     CountryService.saveCountry(countryData);
    //         //   });
    //         // } else {
    //         //   this.getNowShowingData();
    //         //   this.getAllFilters();
    //         // }
    //       }
    //     })
    //     .catch(error => {
    //       console.log("Error", error);
    //       //   resolve(null);
    //     });
    // },
    getGeoLocation: function() {
      if (navigator.geolocation) {
        //navigator.geolocation.getCurrentPosition(showPosition);
      } else {
        x.innerHTML = "Geolocation is not supported by this browser.";
      }

      function showPosition(position) {
        let _position = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude
        };
        window.localStorage.setItem("Geolocation", JSON.stringify(_position));
      }
    },
    onShowCurrentModal: function(ref) {
      console.log("ref :", ref);
      this.$refs[ref].show();
    },
    onCloseCurrentModal: function(ref) {
      this.$refs[ref].hide();
    },
    onCloseModal: function() {
      this.$refs.shareModal.hide();
    },
    onfbshare() {
      console.log("onfbshareonfbshareonfbshareonfbshare");
      window.open(
        "fb-messenger://share?link=" +
          encodeURIComponent(this.messageCopy) +
          "&app_id=" +
          encodeURIComponent("304861010210706")
      );
    },
    onCopy: function(e) {
      this.messageCopy = e.text;
      console.log("e.text :", e.text);
      this.$toasted.show("Link copied to clipboard");
      setTimeout(() => {
        this.$toasted.clear();
      }, 3000);
    },
    onsharefriend: function() {
      console.log("onsharefriend");
      this.$root.$emit("bv::show::modal", "shareModal");
    },
    onClickLogo: function() {
      // this.getAllCountry();

      this.$router.push({ name: "Home" });
      // EventBus.$emit("onClickLogo");
    },
    onClickHome: function() {
      // this.getAllCountry();
      this.$router.push({ name: "Home" });
    },
    getAllGetCountryList: function() {
      makeRequest("/GetCountryCode", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            this.CountryCodeList = res.data.List;
            this.DefaultCountryCode = res.data.Default.CountryCode || res.data.List.length ? res.data.List[0].CountryISOCode : ''
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    onFocusOut() {
      setTimeout(() => {
        this.movieListSearch = [];
        this.cinemaListSearch = [];
      }, 500);
    },
    // api/dashuser/GetContentLang/
    onChangeLanguage: function(lang) {
      let language = {
        iso_2: lang.ISOCode,
        name: lang.LanguageName,
        lang: lang.ISOCode,
        lang_id: lang.LanguageID
      };
      LanguageService.saveLanguage(language);
      this.$store.commit('SET_CURRENT_LANGUAGE', language)
      setI18nLanguage( lang.ISOCode.toLowerCase());
       this.selectedLang =  lang.ISOCode? lang.ISOCode.toLowerCase():'en'
    },
    hideCountryModal: function() {
      EventBus.$emit("onClickLogo");
      this.$refs.countryModalRef.hide();
    },
    fetchLanguageData: function() {
      makeRequest(`/GetContentLang`, "POST", null, null)
        .then(result => {
          this.languageData = result.res.data.List;
          // this.languageData = this.languageData.filter(x => {
          //   return x.ISOCode == "en";
          // });
          console.log( this.languageData,"sdfsdfsdfds")
        })
        .catch(error => {
          console.log(" Error", error);
        });
    },
    fetchUserDetails: function() {
      let token = TokenService.getToken();
      if (token) {
        makeRequest(`/GetProfile`, "POST", token, null)
          .then(result => {
            this.myUserDetails = result.res.data;
            EventBus.$emit("UserLoggedIn", this.myUserDetails);
            this.isUserLoggedIn = true;
            console.log("profile dara", this.myUserDetails.ReferalCodeURL);
            if (
              this.project == "wanasatime" &&
              this.referralCode != "" &&
              this.showBonusPopup
            ) {
              console.log("project:", this.project);
              console.log("this.referralCode :", this.referralCode);
              this.onShowCurrentModal("registerbonusoffer");
            }
            if (this.myUserDetails.FirstName == "") {
              this.myUserDetails.displayName = this.myUserDetails.Email.split(
                "@"
              )[0];
            } else {
              this.myUserDetails.displayName = this.myUserDetails.FirstName;
            }
            this.messageCopy = this.myUserDetails.ReferalCodeURL;
          })
          .catch(error => {
            console.log(" Error", error);
          });
      }
    },
    onChangeCountry: function(country) {
      this.DefaultCountryCode = country.CountryISOCode;
    },
    saveLangToken: function(lang) {
      LanguageService.saveLanguage(lang);
      window.location.reload();
    },
    searchData: function() {
      if (this.searchValue.length > 0) {
        this.searchAPI();
        // } else if (this.searchValue.length == 0) {
        //   this.movieListSearch = [];
        //   this.cinemaListSearch = [];
      } else {
        this.movieListSearch = [];
        this.cinemaListSearch = [];
      }
    },
    onSelectQuery: function(query) {
      this.selectedQuery = query;
    },
    searchAPI: function() {
      let payload = {
        term: this.searchValue
      };
      makeRequest(`/Search`, "POST", null, payload)
        .then(result => {
          this.movieListSearch = result.res.data.Movies;
          this.cinemaListSearch = result.res.data.Cinema;
        })
        .catch(error => {
          console.log("Google Login Error", error);
        });
    },

    showForgotPassword: function() {
      this.hideSignIn();
      this.$refs.forgotPassword.show();
      this.modal.forgotPassword.info = true;
    },
    hideForgotPassword: function() {
      // this.userDetails = {};

      this.$refs.forgotPassword.hide();
      this.modal.forgotPassword.info = true;
      this.modal.forgotPassword.OTP = false;
      this.modal.forgotPassword.resetPassword = false;
    },

    hideSignIn: function() {
      //
      this.userDetails.signinmodel = null;
      this.userDetails.password = null;
      this.$refs.signInModal.hide();
      this.resErrorMessage.signInError = "";
      this.errors.clear("signIn");
      this.$validator.reset();
      this.modal.signIn.OTP = false;
      this.modal.signIn.info = true;
    },
    hideSignUp: function() {
      this.userDetails = {};
      this.$refs.signUpModal.hide();
      this.errors.clear("signUp");
      this.$validator.reset();
      this.resErrorMessage.signUpError = "";
      this.modal.signUp.OTP = false;
      this.modal.signUp.info = true;
    },
    validateBeforeSubmit(scope) {
      if (scope == "signIn") {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.showLoading();
            let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let bool = emailreg.test(this.userDetails.signinmodel);
            let payload = {};
            if (!bool) {
              payload = {
                Email: "",
                Mobile: this.userDetails.signinmodel,
                CountryCode: this.userDetails.countryCode || "91",
                Password: this.userDetails.password
              };
            } else {
              this.userDetails.email = this.userDetails.signinmodel;
              payload = {
                Email: this.userDetails.signinmodel,
                Mobile: "0",
                CountryCode: this.userDetails.countryCode || "91",
                Password: this.userDetails.password
              };
            }
            makeRequest("/Login", "POST", null, payload)
              .then(response => {
                this.hideLoading();
                const { error, res } = response;
                if (res.data.Status) {
                  TokenService.saveToken(res.data.access_token);
                  // firebase
                  //   .auth()
                  //   .signInWithEmailAndPassword(
                  //     this.userDetails.signinmodel,
                  //     this.userDetails.password
                  //   )
                  //   .then(
                  //     user => {
                  //       alert("well done you are connected");
                  //     },
                  //     err => {
                  //       alert("Oops. " + err.message);
                  //     }
                  //   );
                  this.hideSignIn();
                  this.hideSignUp();
                  this.loggedInFlag = true;
                  this.fetchUserDetails();
                  this.loginUser(res.data.access_token);
                } else {
                  this.resErrorMessage.signInError = res.data.Message;
                }
              })
              .catch(error => {
                this.resErrorMessage.signInError = "Something went wrong";
                console.log("Error", error);
                //   resolve(null);
              });
            // alert("Form Submitted!");
            return;
          }
        });
      }
      if (scope == "contactUs") {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            let payload = {
              Name: this.contactUsDetails.name,
              Email: this.contactUsDetails.email,
              Phone: this.contactUsDetails.mobile,
              Message: this.contactUsDetails.message,
              Query: this.selectedQuery
            };
            makeRequest("/ContactUs", "POST", null, payload)
              .then(response => {
                const { error, res } = response;
                if (res.data.Status) {
                  this.contactUsDetails.errorMessage = res.data.Message;
                  setTimeout(() => {
                    this.$refs.support.hide();
                  }, 2000);
                } else {
                  this.contactUsDetails.errorMessage = res.data.Message;
                }
              })
              .catch(error => {
                this.contactUsDetails.errorMessage = "Something went wrong";
              });
          }
        });
      }
      if (scope == "forgotPassword") {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.showLoading();
            let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let bool = emailreg.test(this.userDetails.signinmodel);
            let payload = {};
            if (!bool) {
              payload = {
                Email: "",
                Mobile: this.userDetails.signinmodel,
                CountryCode: this.userDetails.countryCode || "91",
                VerifyMe: true
              };
            } else {
              this.userDetails.email = this.userDetails.signinmodel;
              payload = {
                Email: this.userDetails.signinmodel,
                Mobile: "0",
                CountryCode: this.userDetails.countryCode || "91",
                VerifyMe: true
              };
            }
            makeRequest("/Register", "POST", null, payload)
              .then(response => {
                this.hideLoading();
                const { error, res } = response;
                if (res.data.Status) {
                  this.modal.forgotPassword.info = false;
                  this.modal.forgotPassword.OTP = true;
                } else {
                  this.resErrorMessage.signInError = res.data.Message;
                }
              })
              .catch(error => {
                this.resErrorMessage.signInError = "Something went wrong";
                console.log("Error", error);
              });
            // alert("Form Submitted!");
            return;
          }
        });
      }
      if (scope == "signUp") {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.verifyMe = false;
            this.registerApi();
            // alert("Form Submitted!");
            return;
          }
        });
      }
      if (scope == "signInVerifyOTP") {
        this.verifyUser();
      }
      if (scope == "signUpVerifyOTP") {
        this.verifyUserSignUp();
      }
      if (scope == "forgotPasswordOTP") {
        this.verifyForgotPassword();
      }
      if (scope == "updateProfile") {
        // let token = TokenService.getToken();
        let token = this.tempToken ? this.tempToken : TokenService.getToken();
        console.log("Forgot Password token", token);
        let payload = {
          FirstName: this.userDetails.FirstName,
          LastName: this.userDetails.LastName,
          CountryCode: this.userDetails.CountryCode,
          Mobile: this.userDetails.Mobile,
          Gender: this.selected,
          Email: this.userDetails.Email,
          Password: this.userDetails.NewPassword,
          RePassword: this.userDetails.repassword
        };
        makeRequest(`/UpdateProfile`, "POST", token, payload)
          .then(result => {
            if (result.res.data.Status) {
              this.tempToken ? TokenService.saveToken(this.tempToken) : "";

              this.$refs.forgotPassword.hide();
              this.modal.forgotPassword.info = true;
              this.modal.forgotPassword.OTP = false;
              this.modal.forgotPassword.resetPassword = false;
            } else {
              this.resErrorMessage.otpError = result.res.data.Message;
            }
          })
          .catch(error => {
            console.log(" Error", error);
          });
      }
    },
    registerApi: function() {
      this.showLoading();
      let payload = {};
      payload = {
        FullName: this.userDetails.fullName,
        Email: this.userDetails.email,
        Mobile: this.userDetails.phoneNumber || "0",
        Password: this.userDetails.password,
        RePassword: this.userDetails.password,
        Gender: this.selected,
        CountryCode: this.userDetails.countryCode || "91",
        ReferredBy: this.referralCode,
        VerifyMe: this.verifyMe,
        Password: this.userDetails.password,
        RePassword: this.userDetails.password
      };
      makeRequest("/Register", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          this.hideLoading();
          if (res.data.Status) {
            this.modal.signUp.info = false;
            this.modal.signUp.OTP = true;
          } else {
            this.verifyMe = !res.data.verifyemail || !res.data.verifymobile;
            this.resErrorMessage.signUpError = res.data.Message;
          }
        })
        .catch(error => {
          this.resErrorMessage.signUpError = error;
          console.log("Error", error);
          //   resolve(null);
        });
    },

    verifyForgotPassword: function() {
      let payload = {
        Email: this.userDetails.email,
        Mobile: this.userDetails.phoneNumber || "0",
        CountryCode: "91",
        OTP: this.userDetails.OTP,
        FirebaseToken:
          "dSGHl9k_3eI:APA91bGmRzVggwlGr5pUISlD9f73uuCiysoEOG4GakPyXHmswjPlYZmY83tx1aPlH0W-5HTCsUCUYgIyfUzn0NX-wzv7LelazjLhuC46ASl2ySZdUQDYAyZOUjlKqLpDNqyiFRqtQSmZ",
        FromDevice: "IOS",
        DeviceModel: "iPhone X"
      };

      console.log("Verify OTP Payload", payload);

      makeRequest("/VerifyUser", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          console.log(res);
          if (res.data.Status) {
            this.modal.forgotPassword.OTP = false;
            this.modal.forgotPassword.resetPassword = true;
            // TokenService.saveToken(res.data.access_token);
            this.tempToken = res.data.access_token;
            this.fetchUserDetails();
          } else {
            this.resErrorMessage.Attempt = res.data.Attempt || false;
            this.resErrorMessage.otpError = res.data.Message;
          }
        })
        .catch(error => {
          this.resErrorMessage.otpError = error;
          console.log("Error", error);
          //   resolve(null);
        });
    },

    verifyUserSignUp: function() {
      this.resErrorMessage.otpError = "";
      // let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // let bool = emailreg.test(this.userDetails.signinmodel);

      let payload = {
        Email: this.userDetails.email,
        Mobile: this.userDetails.phoneNumber || "0",
        CountryCode: "91",
        OTP: this.userDetails.OTP,
        FirebaseToken:
          "dSGHl9k_3eI:APA91bGmRzVggwlGr5pUISlD9f73uuCiysoEOG4GakPyXHmswjPlYZmY83tx1aPlH0W-5HTCsUCUYgIyfUzn0NX-wzv7LelazjLhuC46ASl2ySZdUQDYAyZOUjlKqLpDNqyiFRqtQSmZ",
        FromDevice: "IOS",
        DeviceModel: "iPhone X"
      };

      makeRequest("/VerifyUser", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            TokenService.saveToken(res.data.access_token);
            this.hideSignIn();
            this.hideSignUp();
            this.loggedInFlag = true;
            this.fetchUserDetails();
            this.loginUser(res.data.access_token);
            this.modal.signIn.info = true;
            this.modal.signIn.OTP = false;
            this.showBonusPopup = true;
          } else {
            this.resErrorMessage.Attempt = res.data.Attempt || false;
            this.resErrorMessage.otpError = res.data.Message;
          }
        })
        .catch(error => {
          this.resErrorMessage.otpError = error;
          console.log("Error", error);
          //   resolve(null);
        });
      return;
    },
    verifyUser: function() {
      this.resErrorMessage.otpError = "";
      let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let bool = emailreg.test(this.userDetails.signinmodel);

      let payload = {
        Email: this.userDetails.signinmodel,
        Mobile: this.userDetails.signinmodel || "0",
        CountryCode: "91",
        OTP: this.userDetails.OTP,
        FirebaseToken:
          "dSGHl9k_3eI:APA91bGmRzVggwlGr5pUISlD9f73uuCiysoEOG4GakPyXHmswjPlYZmY83tx1aPlH0W-5HTCsUCUYgIyfUzn0NX-wzv7LelazjLhuC46ASl2ySZdUQDYAyZOUjlKqLpDNqyiFRqtQSmZ",
        FromDevice: "IOS",
        DeviceModel: "iPhone X"
      };
      if (!bool) {
        payload.Email = "";
      }
      makeRequest("/VerifyUser", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            TokenService.saveToken(res.data.access_token);
            this.hideSignIn();
            this.hideSignUp();
            this.loggedInFlag = true;
            this.fetchUserDetails();
            this.loginUser(res.data.access_token);
            this.modal.signIn.info = true;
            this.modal.signIn.OTP = false;
          } else {
            this.resErrorMessage.otpError = res.data.Message;
          }
        })
        .catch(error => {
          this.resErrorMessage.otpError = error;
          console.log("Error", error);
          //   resolve(null);
        });
      return;
    },
    loginUser: function(token) {
      if (token) {
        makeRequest("/GetProfile", "POST", token, null)
          .then(result => {
            const { error, res } = result;
            if (!error && res.status) {
              this.myUserDetails = res.data;
              EventBus.$emit("UserLoggedIn", this.myUserDetails);
              EventBus.$emit("onProfileSuccess");
              if (
                this.project == "wanasatime" &&
                this.referralCode != "" &&
                this.showBonusPopup
              ) {
                console.log("this.referralCode :", this.referralCode);
                this.onShowCurrentModal("registerbonusoffer");
              }
              if (this.myUserDetails.FirstName === "") {
                this.myUserDetails.displayName = this.myUserDetails.Email.split(
                  "@"
                )[0];
              } else {
                this.myUserDetails.displayName = this.myUserDetails.FirstName;
              }
            } else {
              console.log("error from res", res.message);
            }
          })
          .catch(error => {
            console.log("Error on vue front", error);
          });
      }
    },
    getAllCountry: function(country) {
      let countryData = CountryService.getCountry();
      console.log("country from db", countryData);
      makeRequest("/GetCountryList", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          // first time with no data
          // if (window.location.origin == "https://uae.ticketak.com") {
          //   CountryService.saveCountry(res.data.List[1]);
          //   // window.location.reload();

          //   this.$refs.countryModalRef.hide();

          //   //
          // } else if (window.location.origin == "https://kw.ticketak.com") {
          //   CountryService.saveCountry(res.data.List[0]);
          //   // window.location.reload();
          //   this.$refs.countryModalRef.hide();

          //   //
          // } else if (countryData == null) {
          //   if (res.data.Default.CountryISOCode == "UAE") {
          //     window.location.replace("https://uae.ticketak.com");
          //     CountryService.saveCountry(res.data.List[1]);
          //     this.$refs.countryModalRef.hide();

          //     // window.location.reload();
          //   } else if (res.data.Default.CountryISOCode == "KW") {
          //     window.location.replace("https://kw.ticketak.com");
          //     CountryService.saveCountry(res.data.List[0]);
          //     this.$refs.countryModalRef.hide();
          //     // window.location.reload();
          //   } else {
          //     this.$refs.countryModalRef.show();
          //   }
          // }
          // // with UAE
          // else if (
          //   res.data.Default.CountryISOCode == "KW" &&
          //   countryData.CountryName == "UAE"
          // ) {
          //   window.location.replace("https://uae.ticketak.com");
          // } //with KW
          // else if (
          //   res.data.Default.CountryISOCode == "UAE" &&
          //   countryData.CountryName == "Kuwait"
          // ) {
          //   window.location.replace("https://kw.ticketak.com");
          // } else if (
          //   window.location.origin == "https://kw.ticketak.com" &&
          //   res.data.Default.CountryISOCode == "UAE" &&
          //   countryData.CountryName == "UAE"
          // ) {
          //   window.location.replace("https://kw.ticketak.com");
          // } else if (
          //   window.location.origin == "https://uae.ticketak.com" &&
          //   res.data.Default.CountryISOCode == "KW" &&
          //   countryData.CountryName == "KW"
          // ) {
          //   window.location.replace("https://uae.ticketak.com");
          // }

          if (!error && res.data.Status) {
            // if (countryData == null) {
            //   if (res.data.Default.CountryID === 0) {
            //     CountryService.saveCountry(res.data.Default);
            //   } else if (this.project == "ticketak") {
            //     //this.$refs.countryModalRef.show();
            //   }
            // } else {
            //   // this.redirectDomain(countryData.CountryName);
            // }

            this.countries = res.data.List;
            if (this.project == "ticketak") {
              this.countries.map(x => {
                if (x.CountryID == "230" || x.CountryID == "112") {
                  countryData = x;
                  this.countrySelected = x.CountryName;
                }
                CountryService.saveCountry(countryData);
              });
            }
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    getAllCity: function(country) {
      makeRequest(
        "/app/getcitylist?countryId=" + this.countrySelected.ID,
        "POST",
        null,
        null
      )
        .then(response => {
          const { error, res } = response;
          console.log("city", response);
          if (!error && res.data.Status) {
            this.city = res.data.Cities;
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    redirectDomain(country) {
      if (
        country == "UAE" &&
        window.location.origin != "https://uae.ticketak.com"
      ) {
        window.location.replace("https://uae.ticketak.com");
      }
      //kw
      else if (
        country == "Kuwait" &&
        window.location.origin != "https://kw.ticketak.com"
      ) {
        window.location.replace("https://kw.ticketak.com");
      }
    },
    setCountry: function(country) {
      CountryService.saveCountry(country);
      // this.countrySelected = country;
      this.countrySelected = country.CountryName;
      // this.redirectDomain(this.countrySelected);
      window.location = "/";
    },
    setCity: function(city) {
      this.$persistStore.set("city", JSON.stringify(city));
      window.location = "/";
    },
    theScroll: function() {
      if (window.scrollY >= 30) {
        this.onScroll = false;
      } else {
        this.onScroll = true;
      }
    },
    handleScroll: function() {
      var that = this;
      throttle(that.theScroll, 2000);
    },

    hideContactUs: function() {
      // window.location.href = "/";
      this.$refs.support.hide();
      this.contactUsDetails = {};
    },

    forgotPasswordOpenSend: function(section) {
      console.log("f");
      if (section == "step1") {
        this.forgotPasswordSection = 1;
      } else if (section == "step2") {
        let payload = {
          UserName: this.inputData.userName
        };
        makeRequest("/api/Account/Forgot/", "POST", null, payload)
          .then(response => {
            //   console.log("Country List Here >>>", response);
            const { error, res } = response;
            console.log("forgotpass1 response", response);
            if (!error && res.data.Status) {
              this.inputData.ReSetCode = res.data.ReSetCode;
              this.forgotPasswordSection = 2;
              // this.cities = res.data.Cities;
              // console.log("Country >>", this.country);
            }
          })
          .catch(error => {
            console.log("Error", error);
            //   resolve(null);
          });
      } else {
        let payload = {
          ReSetCode: this.inputData.ReSetCode,
          Password: this.inputData.password,
          SecureCode: this.inputData.code
        };
        makeRequest("/api/Account/ResetPassword/", "POST", null, payload)
          .then(response => {
            //   console.log("Country List Here >>>", response);
            const { error, res } = response;
            console.log("forgotpass2 response", response);
            if (!error && res.data.Status) {
              this.forgotPasswordSection = 3;
              // this.cities = res.data.Cities;
              // console.log("Country >>", this.country);
            }
          })
          .catch(error => {
            console.log("Error", error);
            //   resolve(null);
          });

        // this.forgotPasswordSection = 3;
      }
    },
    onGoogleSignInSuccess(googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users

      console.log("googleUser", googleUser);
      this.showLoading();
      const profile = googleUser.getBasicProfile();
      makeRequest(`/SocialLogin`, "POST", null, {
        FireBaseID: "",
        TokenFrom: "Google",
        stoken: googleUser.Zi ? googleUser.Zi.id_token : googleUser.wc.id_token,
        ReferredBy: this.referralCode
      })
        .then(result => {
          this.hideLoading();
          TokenService.saveToken(result.res.data.access_token);
          this.hideSignIn();
          this.hideSignUp();
          this.loggedInFlag = true;
          this.loginUser(result.res.data.access_token);
          this.loggedInFlag = true;
        })
        .catch(error => {
          console.log("Google Login Error", error);
        });
    },
    onGoogleSignInError(error) {
      this.socialLoginError.error = "Something went wrong!";
      setTimeout(() => {
        this.socialLoginError.error = "";
      }, 5000);
    },
    onSignFBInSuccess(response) {
      makeRequest(`/SocialLogin`, "POST", null, {
        FireBaseID: "",
        TokenFrom: "Facebook",
        stoken: response.authResponse.accessToken,
        ReferredBy: this.referralCode
      })
        .then(result => {
          console.log("Check Socal Facebook response From here ", result);
          TokenService.saveToken(result.res.data.access_token);
          this.hideSignIn();
          this.hideSignUp();
          this.loggedInFlag = true;
          this.loginUser(result.res.data.access_token);
          //result has
        })
        .catch(error => {
          console.log("Face book Login Error", error);
        });
      // Testing;
      FB.api("/me", data => {
        console.log("Facebook Data ", data);
      });
    },
    onSignFBInError(error) {
      this.socialLoginError.error = "Whoops, !Something went wrong";
      setTimeout(() => {
        this.socialLoginError.error = "";
      }, 5000);
    },

    showLoginModal: function() {
      this.loginDiv = true;
    },
    logOut: function() {
      this.loggedInFlag = false;
      this.$persistStore.remove("accessToken");

      makeRequest(`/api/Account/SocialLogin`, "POST", null, {
        FireBaseID: "",
        TokenFrom: "Google",
        stoken: googleUser.Zi.id_token
      });
    },

    CheckLoginFun: function(data) {
      console.log("gmamamam", data);
    },

    openMobileSearch() {},

    handleMobileSearch() {
      console.log("Search Movies Here", this.mobileSearch);
      if (this.mobileSearch) {
        this.onSearchInputChange("");
        this.mobileSearch = false;
      } else {
        this.mobileSearch = true;
      }
    },

    onSearchItemSelected(item) {
      console.log("item", item);
      this.selectedSearchMovie = item;
      this.searchQuery = item && item.hasOwnProperty("Name") ? item.Name : "";

      let name = item.Name.replace(/\s/g, "-").toLowerCase();
      var payload = {
        categoryId: item.ShowCat,
        movieId: item.ID,
        movieName: item.Name
      };
      // this.$store.dispatch("setMoviesDetails", payload);
      // this.$store.dispatch("setLeadItem", "FIFIFIFIF");
      //   localforage.setItem("NAMEME", "SAIF");
      this.$persistStore.set("GetMovieDetails", JSON.stringify(payload));
      //   this.$store.dispatch("setMoviesDetails", payload);
      // this.$router.push({
      //   path: "/movies",
      //   params: {}
      // });

      if (item.ShowCat == 4) {
        this.$router.push({
          path: "/create-movie-screen",
          params: {}
        });
      } else if (item.ShowCat == 2) {
        this.$router.push({
          path: "/special-movie-screen",
          params: {}
        });
      } else if (item.ShowCat == 1) {
        this.$router.push({
          path: "/movie-details",
          params: {}
        });
      } else if (item.ShowCat == 3) {
        this.$router.push({
          path: "/movie-details",
          params: {}
        });
      }
    },
    handlerOtpFocus: function() {
      // v-on:focus.native="handlerOtpFocus()"
      console.log("inside the focus");
      this.otpDetails.otpError.message = "";
    },
    handlerOtpValidation: function(id) {
      this.otpDetails.otpError.message = "";

      if (id == "first") {
        this.otpDetails.otpInputs.first = this.otpDetails.otpInputs.first.slice(
          0,
          1
        );
      } else if (id == "second") {
        this.otpDetails.otpInputs.second = this.otpDetails.otpInputs.second.slice(
          0,
          1
        );
      } else if (id == "third") {
        this.otpDetails.otpInputs.third = this.otpDetails.otpInputs.third.slice(
          0,
          1
        );
      } else if (id == "fourth") {
        this.otpDetails.otpInputs.fourth = this.otpDetails.otpInputs.fourth.slice(
          0,
          1
        );
      }
      this.otpDetails.status.buttonFlag =
        Object.keys(this.otpDetails.otpInputs).filter(
          x => this.otpDetails.otpInputs[x] !== ""
        ).length == 4
          ? false
          : true;
    },
    backBrowsing: function(id) {
      console.log("id", id);
      $(id).modal("toggle");
      this.$router.push({
        path: "/",
        params: {}
      });
    },
    // Social Login Start
    onGoogleSignIn(id) {
      //call-Google-Auth
      console.log("Google Call", id);
    },
    onGoogleSuccess(success) {
      console.log("on Success >>", success);
      // this.$persistStore.set("accessToken", data.result.access_token);
      //     this.loggedInFlag = true;
      //     window.location = "/";
    },
    onGoogleFailure(fail) {
      console.log("on Failure google", fail);
    },

    // social facebook
    onFacebookLogin: function() {
      console.log(">>>>> social login");
      //   makeRequest("/app/social-signin", "POST", null)
      //     .then(response => {
      //       const { error, res } = response;
      //       const { data } = res.data;
      //       console.log("checking social-signin");
      //     })
      //     .catch(error => {
      //       console.log("Error", error);
      //       //   resolve(null);
      //     });
    },

    // LOGIN PROCESS

    onLogout() {
      // let token = TokenService.getToken();
      // makeRequest("/AccountLogout", token, null)
      //   .then(result => {
      //     const { data } = result;
      //     if (data.Status) {
      window.localStorage.removeItem("access_token");
      TokenService.removeToken();
      window.location.reload();
      window.location.pathname = "/";
      this.loggedInFlag = false;
      // }
      //   console.log("result :", result);
      // })
      // .catch(err => {});
    },

    handlerLoginValidation: function(name, flag) {
      this.resErrorMessage.signInError = "";
      //   console.log(
      //     "MMMMMMMM",
      //     this.emailReg.test(this.loginData.loginInput.email)
      //   );
      if (name == "email") {
        // this.errorMessage.email = "";
        this.loginData.errorMessage.email =
          this.loginData.loginInput.email == ""
            ? ""
            : this.emailReg.test(this.loginData.loginInput.email)
            ? ""
            : "error";
        this.loginData.errorMessageStatus.email = this.emailReg.test(
          this.loginData.loginInput.email
        );
      } else if (name == "password") {
        let passwordRege = /(?=.{4,})/;
        this.loginData.errorMessage.password =
          this.loginData.loginInput.password == ""
            ? ""
            : passwordRege.test(this.loginData.loginInput.password)
            ? ""
            : "error";
        this.loginData.errorMessageStatus.password = passwordRege.test(
          this.loginData.loginInput.password
        );
      } else if (name == "conditions") {
        this.loginData.errorMessage.conditions = this.loginData.loginInput.conditions;
        this.loginData.errorMessageStatus.conditions = this.loginData.loginInput.conditions;
      }
      this.checkButtonLoginStatus();
    },
    checkButtonLoginStatus() {
      //   console.log(
      //     this.loginData,
      //     "Here Login",
      //     this.loginData.button,
      //     Object.keys(this.loginData.errorMessageStatus).filter(
      //       x => this.loginData.errorMessageStatus[x] == true
      //     ).length
      //   );
      this.loginData.button =
        Object.keys(this.loginData.errorMessageStatus).filter(
          x => this.loginData.errorMessageStatus[x] == true
        ).length == 3
          ? false
          : true;
    },

    onSubmitLogin: function() {
      // this.resErrorMessage.signInError = "";
      //   console.log("here >>");
      let payload = {
        UserName: this.loginData.loginInput.email,
        Password: this.loginData.loginInput.password
      };
      makeRequest("/api/signin", "POST", null, payload)
        .then(response => {
          const { error, res } = response;
          const { data } = res.data;
          if (!error && res.data.status && data.result.Status) {
            console.log("checking otp succ", data);
            this.showSeatNoModal("#signin-page");
            // this.$cookies.set("access_token", data.result.access_token, "1d");

            this.userName = data.result.UserName;
            // this.loggedFlag = true;
            EventBus.$emit("UserLogged", {
              status: true,
              userName: data.result.UserName
            });
            // userLoggedIn();
          } else {
            // console.log("Error in reuqst ", data.result.Message);
            // this.otpDetails.otpError.message = data.result.Message;
            // setTimeout(() => {
            //   this.otpDetails.otpError.message = "";
            // }, 5000);
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    userSignout() {
      this.$cookies.remove("access_token");
      // remove a cookie
      this.$cookies.remove("HUID");
      this.loggedFlag = false;
      this.userName = "";
    }
  },
  watch: {
    $route(to, from) {
      this.searchValue = "";
    },
    searchValue: function(newVal, oldVal) {
      console.log("val>>", newVal, oldVal);
    }
  },
  updated: function() {
    // console.log("t", this.page);
    this.page = this.$route.path;
  },
  destroyed() {
    this.searchValue = "";
  }
};
</script>
<style scoped>
/* .search_modal_sub{
     background: transparent !important;
} */
/* .modal-body{
    background: red  !important;
} */
/* .search-modal-sub{
    background: red  !important;

} */
/* .modal.show .modal-dialog{
    background-color: transparent !important;
} */
/* .search-modal-sub > .modal-body{
    background-color: blue !important;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/search.vue